import { useLiveViewStateStore } from '../LiveViewStore'

const MAX_POINTS = 4 // Number of points per overlay
const MAX_OVERLAYS_DEFAULT = 8 // Maximum number of overlays allowed

export const useSupportedFunctionalities = () => {
    const { supported_functionalities } = useLiveViewStateStore()
    let maxPoints = MAX_POINTS
    let MAX_OVERLAYS = MAX_OVERLAYS_DEFAULT
    let IS_BLACK_MASK_SUPPORTED = true
    let IS_POLYGON_SUPPORTED = true
    let IS_AUTOFUNC_SUPPORTED = true
    let IS_ZOOM_FOCUS_SUPPORTED = true
    let IS_BRIGHTNESS_SUPPORTED = true
    let IS_SNAPSHOT_SUPPORTED = true
    let IS_LIVE_VIEW_SUPPORTED = true
    let IS_REGIONAL_AUTOFOCUS_SUPPORTED = true

    if (supported_functionalities?.black_mask?.max_polygon_points) {
        maxPoints = supported_functionalities.black_mask.max_polygon_points
    }

    if (supported_functionalities?.black_mask?.max_masks) {
        MAX_OVERLAYS = supported_functionalities.black_mask.max_masks
    }

    if (!supported_functionalities?.black_mask?.shape_types?.includes('polygon')) {
        IS_POLYGON_SUPPORTED = false
    }

    if (!supported_functionalities?.black_mask?.supported) {
        IS_BLACK_MASK_SUPPORTED = false
    }

    if (!supported_functionalities?.autofocus) {
        IS_AUTOFUNC_SUPPORTED = false
    }

    if (!supported_functionalities?.zoom_focus) {
        IS_ZOOM_FOCUS_SUPPORTED = false
    }

    if (!supported_functionalities?.brightness) {
        IS_BRIGHTNESS_SUPPORTED = false
    }

    if (!supported_functionalities?.snapshot) {
        IS_SNAPSHOT_SUPPORTED = false
    }

    if (!supported_functionalities?.live_view) {
        IS_LIVE_VIEW_SUPPORTED = false
    }

    if (!supported_functionalities?.regional_autofocus) {
        IS_REGIONAL_AUTOFOCUS_SUPPORTED = false
    }

    return {
        maxPoints,
        MAX_OVERLAYS,
        IS_BLACK_MASK_SUPPORTED,
        IS_POLYGON_SUPPORTED,
        IS_ZOOM_FOCUS_SUPPORTED,
        IS_BRIGHTNESS_SUPPORTED,
        IS_SNAPSHOT_SUPPORTED,
        IS_LIVE_VIEW_SUPPORTED,
        IS_REGIONAL_AUTOFOCUS_SUPPORTED
    }
}
